// frontend/src/components/SupplierInvoices/SupplierInvoiceFilters.jsx
import React from 'react';
import { Search, X } from 'lucide-react';

const SupplierInvoiceFilters = ({ filters, setFilters, suppliers }) => {
  const update = (key, val) => setFilters(prev => ({ ...prev, [key]: val }));

  const hasActive = Object.values(filters).some(v => v !== '');

  const reset = () => setFilters({
    search: '', status: '', invoice_type: '',
    supplier_id: '', start_date: '', end_date: '',
  });

  return (
    <div className="bg-gray-800/50 rounded-xl p-4 border border-gray-700">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col sm:flex-row gap-3">

          {/* Search */}
          <div className="relative flex-1">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search by invoice #, supplier, ref..."
              value={filters.search}
              onChange={e => update('search', e.target.value)}
              className="w-full bg-gray-900 border border-gray-700 rounded-lg pl-9 pr-4 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-indigo-500"
            />
          </div>

          {/* Supplier */}
          <select
            value={filters.supplier_id}
            onChange={e => update('supplier_id', e.target.value)}
            className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-indigo-500"
          >
            <option value="">All Suppliers</option>
            {suppliers.map(s => (
              <option key={s.id} value={s.id}>{s.company_name}</option>
            ))}
          </select>

          {/* Status */}
          <select
            value={filters.status}
            onChange={e => update('status', e.target.value)}
            className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-indigo-500"
          >
            <option value="">All Statuses</option>
            <option value="received">Received</option>
            <option value="pending">Pending</option>
            <option value="paid">Paid</option>
            <option value="disputed">Disputed</option>
            <option value="cancelled">Cancelled</option>
          </select>

          {/* Type */}
          <select
            value={filters.invoice_type}
            onChange={e => update('invoice_type', e.target.value)}
            className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-indigo-500"
          >
            <option value="">All Types</option>
            <option value="purchase">Purchase</option>
            <option value="recurring_charge">Recurring Charge</option>
          </select>
        </div>

        {/* Date range */}
        <div className="flex flex-col sm:flex-row gap-3 items-center">
          <div className="flex items-center gap-2 flex-1">
            <label className="text-xs text-gray-400 whitespace-nowrap">From:</label>
            <input
              type="date"
              value={filters.start_date}
              onChange={e => update('start_date', e.target.value)}
              className="flex-1 bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-indigo-500"
            />
          </div>
          <div className="flex items-center gap-2 flex-1">
            <label className="text-xs text-gray-400 whitespace-nowrap">To:</label>
            <input
              type="date"
              value={filters.end_date}
              onChange={e => update('end_date', e.target.value)}
              className="flex-1 bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-indigo-500"
            />
          </div>
          {hasActive && (
            <button
              onClick={reset}
              className="flex items-center gap-1 px-3 py-2 text-sm text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg transition-colors whitespace-nowrap"
            >
              <X size={14} /> Clear
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupplierInvoiceFilters;